exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket-title-line[data-v-336f4889] {\n  margin: 5px 0 0 -15px;\n  padding: 0 0 0 15px;\n  border-bottom: 1px solid #f7f7f7;\n}\n.ticket-title-line-1[data-v-336f4889] {\n  overflow:hidden;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n  display: inline-block;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-336f4889","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketWidgetMyTicketList.vue
// module id = 909
// module chunks = 75